<app-employment-history-list [workerId]="workerId" [isLoggedUserProfile]="isLoggedUserProfile" [workerFormContext]="false"></app-employment-history-list>
